import { api } from "@/lib/api";

/** Fetch the current user's wallet: { cash_cents, promo_cents, spendable_cents, cashable_cents }. */
export async function getWallet() {
  const { data } = await api.get("/wallet");
  return data;
}

/** Fetch credit account history: [{ id, created_at, delta_cents, bucket, label }], newest first. */
export async function getHistory() {
  const { data } = await api.get("/wallet/history");
  return data;
}

/** List buyable credit packs: [{ id, credits_cents, price_cents, label }]. */
export async function listPacks() {
  const { data } = await api.get("/payments/packs");
  return data.packs || [];
}

/** Start a top-up: redirects the browser to Stripe Checkout for the given pack. */
export async function startTopUp(packId) {
  const { data } = await api.post("/payments/checkout/topup", {
    pack_id: packId,
    origin_url: window.location.origin,
  });
  window.location.href = data.url;
}

/** Display helper: integer-credit string from cents (1 credit = 100 cents). */
export const creditsLabel = (cents) => `${Math.round((cents || 0) / 100)}`;
